module.exports = __webpack_public_path__ + "tags.png?9d08e9265f29a22a3103e52edd6c93a3";


//////////////////
// WEBPACK FOOTER
// ./~/@dp/mbase-style/src/less/dp/img/tags.png
// module id = 367
// module chunks = 4